module.exports = {"missingPermission":"Du har tyvärr inte tillgång till denna sida.","contactAdministration":"Kontakta den person i ditt företag som är administratör för detta Trustpilot-konto."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MissingPermission/localization/sv-SE/strings.json
// module id = 1232
// module chunks = 0